import Vue from 'vue'
import Router from 'vue-router'

// import menuModule from 'vuex-store/modules/menu'
import lazyLoading from '../store/modules/menu/lazyLoading'

Vue.use(Router)

export default new Router({
  routes: [
    // ...generateRoutesFromMenu(menuModule.state.items),
    // {
    //   path: '*',
    //   redirect: {
    //     name: getDefaultRoute(menuModule.state.items).name
    //   }
    // },
    {
      name: 'Login',
      path: '/login',
      component: lazyLoading('auth/login/Login'),
      meta: {
        default: false,
        title: 'Login'
      }
    },
    {
      name: 'Profile',
      path: '/profile',
      component: lazyLoading('user/Profile'),
      meta: {
        default: false,
        title: 'Profile'
      }
    },
    {
      name: 'Subscription',
      path: '/subscription',
      component: lazyLoading('user/Subscription'),
      meta: {
        default: false,
        title: 'Subscription'
      }
    },
    {
      name: '',
      path: '/project/:id',
      // default: { template: `<router-view/>` },
      component: lazyLoading('project/Project'),
      canReuse: false,
      meta: {
        expanded: false,
        title: '',
        iconClass: 'vuestic-icon vuestic-icon-dashboard'
      },
      children: [
        {
          name: 'Dash',
          path: 'dash',
          component: lazyLoading('project/dash/Dash'),
          canReuse: false,
          meta: {
            default: false,
            title: 'Dash'
          }
        },
        {
          name: 'PageXplorer',
          path: 'pagexplorer',
          component: lazyLoading('project/pagexplorer/PageXplorer'),
          canReuse: false,
          meta: {
            default: false,
            title: 'PageXplorer'
          }
        },
        {
          name: 'KeyXplorer',
          path: 'keyxplorer',
          component: lazyLoading('project/keyxplorer/KeyXplorer'),
          meta: {
            default: false,
            title: 'KeyXplorer'
          }
        },
        {
          name: 'ErrorXplorer',
          path: 'errors',
          component: lazyLoading('project/errors/Errors'),
          meta: {
            default: false,
            title: 'ErrorXplorer'
          }
        },
        {
          name: 'KeyTracker',
          path: 'keytracker',
          component: lazyLoading('project/keytracker/KeyTracker'),
          meta: {
            default: false,
            expanded: true,
            title: 'KeyTracker'
          }
        },
        {
          name: 'PageTracker',
          path: 'pagetracker',
          component: lazyLoading('project/pagetracker/PageTracker'),
          meta: {
            default: false,
            title: 'PageTracker'
          }
        },
        {
          name: 'Settings',
          path: 'settings',
          component: lazyLoading('project/settings/Settings'),
          meta: {
            default: false,
            title: 'Settings'
          }
        }
      ]
    },
    {
      name: 'New Project',
      path: '/newproject',
      component: lazyLoading('newproject/NewProject'),
      meta: {
        default: true,
        title: 'New Project',
        iconClass: 'fa fa-plus'
      }
    }
  ]
})

// function generateRoutesFromMenu (menu = [], routes = []) {
//   for (let i = 0, l = menu.length; i < l; i++) {
//     let item = menu[i]
//     if (item.path) {
//       routes.push(item)
//     }
//     if (item.children) {
//       generateRoutesFromMenu(item.children, routes)
//     }
//   }
//   return routes
// }
//
// function getDefaultRoute (menu = []) {
//   let defaultRoute
//
//   menu.forEach((item) => {
//     if (item.meta.default) {
//       defaultRoute = item
//     } else if (item.children) {
//       let defaultChild = item.children.find((i) => i.meta.default)
//       defaultRoute = defaultChild || defaultRoute
//     }
//   })
//
//   return defaultRoute
// }



// WEBPACK FOOTER //
// ./src/router/index.js